import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';

export const devPreviewGuard: CanActivateFn = () => {
  if (environment.enableDevPreviewRoutes) {
    return true;
  }
  const router = inject(Router);
  return router.createUrlTree(['/']);
};
